export const DEFAULT_INPUT_TIMEOUT = 300;
export const DEFAULT_RESIZE_TIMEOUT = 300;
export const DEFAULT_CHECKBOX_TIMEOUT = 500;
export const DEFAULT_NETWORK_TIMEOUT = 500;
export const LARGE_NETWORK_TIMEOUT = 1000;
